import {
    GetCreditCardBankTransferDetailsResponse,
    fetchGetCreditCardBankTransferDetails
} from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';

import { useStateKey } from '../../../iwQueryClient/useStateKey';

export const useFetchCreditCardBankDetails = () => {
    const stateKey = useStateKey();

    const { data } = useQuery({
        queryKey: ['credit-card-bank-details', stateKey],
        queryFn: async () => {
            const responseData = await fetchGetCreditCardBankTransferDetails({
                stateKey
            });
            return responseData as GetCreditCardBankTransferDetailsResponse;
        },
        suspense: true,
        select: (response: GetCreditCardBankTransferDetailsResponse) =>
            response.data
    });

    return data;
};
